const BanzaEntityReactionsPresets = {
  BanzaEntityReactions: {
    slots: {
      like: {
        attrs: {
          icon: "iconamoon:like-light",
          iconPressed: "iconamoon:like-duotone",
          iconColor: "#474554",
          iconPressedColor: "#726AF3"
        }
      },
      dislike: {
        attrs: {
          icon: "iconamoon:dislike-light",
          iconPressed: "iconamoon:dislike-duotone",
          iconColor: "#474554",
          iconPressedColor: "#F19B23"
        }
      }
    }
  }
};
export {
  BanzaEntityReactionsPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFFbnRpdHlSZWFjdGlvbnNQcmVzZXRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL2NvbXBvbmVudHMvQmFuemFFbnRpdHlSZWFjdGlvbnNQcmVzZXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcbiAgQmFuemFFbnRpdHlSZWFjdGlvbnM6IHtcbiAgICBzbG90czoge1xuICAgICAgbGlrZToge1xuICAgICAgICBhdHRyczoge1xuICAgICAgICAgIGljb246IFwiaWNvbmFtb29uOmxpa2UtbGlnaHRcIixcbiAgICAgICAgICBpY29uUHJlc3NlZDogXCJpY29uYW1vb246bGlrZS1kdW90b25lXCIsXG4gICAgICAgICAgaWNvbkNvbG9yOiBcIiM0NzQ1NTRcIixcbiAgICAgICAgICBpY29uUHJlc3NlZENvbG9yOiBcIiM3MjZBRjNcIlxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICAgIGRpc2xpa2U6IHtcbiAgICAgICAgYXR0cnM6IHtcbiAgICAgICAgICBpY29uOiBcImljb25hbW9vbjpkaXNsaWtlLWxpZ2h0XCIsXG4gICAgICAgICAgaWNvblByZXNzZWQ6IFwiaWNvbmFtb29uOmRpc2xpa2UtZHVvdG9uZVwiLFxuICAgICAgICAgIGljb25Db2xvcjogXCIjNDc0NTU0XCIsXG4gICAgICAgICAgaWNvblByZXNzZWRDb2xvcjogXCIjRjE5QjIzXCJcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBZSw4QkFBQTtBQUFBLEVBQ2Isc0JBQXNCO0FBQUEsSUFDcEIsT0FBTztBQUFBLE1BQ0wsTUFBTTtBQUFBLFFBQ0osT0FBTztBQUFBLFVBQ0wsTUFBTTtBQUFBLFVBQ04sYUFBYTtBQUFBLFVBQ2IsV0FBVztBQUFBLFVBQ1gsa0JBQWtCO0FBQUEsUUFDbkI7QUFBQSxNQUNGO0FBQUEsTUFDRCxTQUFTO0FBQUEsUUFDUCxPQUFPO0FBQUEsVUFDTCxNQUFNO0FBQUEsVUFDTixhQUFhO0FBQUEsVUFDYixXQUFXO0FBQUEsVUFDWCxrQkFBa0I7QUFBQSxRQUNuQjtBQUFBLE1BQ0Y7QUFBQSxJQUNGO0FBQUEsRUFDRjtBQUNIOyJ9
